import { UiApiCrudClientBaseV1 } from '../crud-client-base'
import type {
  IViewOverride,
  IViewOverrideCreateRequest,
  IViewOverrideDelRequest,
  IViewOverrideGetManyRequest,
  IViewOverrideGetRequest,
  IViewOverridePutRequest,
} from '../../../types'

const BASE_PATH = '/v1/view-overrides'

export class ViewOverrideUiApiClientV1 extends UiApiCrudClientBaseV1<IViewOverride> {
  create = async (request: IViewOverrideCreateRequest) =>
    this.restPost<IViewOverride>(BASE_PATH, request.viewOverride)

  get = async (request: IViewOverrideGetRequest) =>
    this.restGet<IViewOverride>(`${BASE_PATH}/${request.uid}`)

  put = async (request: IViewOverridePutRequest) =>
    this.mergeAndPut(BASE_PATH, request.viewOverride)

  del = async (request: IViewOverrideDelRequest) =>
    this.restDelete(`${BASE_PATH}/${request.uid}`)

  getMany = async (request: IViewOverrideGetManyRequest) => {
    const { limit, page, viewId, name, ...rest } = request as Record<
      string,
      unknown
    >
    const queryParams = this.buildQueryParams({
      limit,
      page,
      viewId,
      name,
      ...rest,
    })
    const response = await this.restGet<{ items: IViewOverride[] }>(
      BASE_PATH,
      queryParams,
    )
    if (!response.items) throw new Error('Invalid response: missing "items"')
    return response.items.map((item) => this.getItem(item))
  }

  public getItem(viewOverride: IViewOverride) {
    const { uid, data, name, viewId, userId, tenantId } = viewOverride
    if (
      !uid ||
      !name ||
      !viewId ||
      userId === undefined ||
      tenantId === undefined
    ) {
      throw Error('Invalid response')
    }
    return {
      ...viewOverride,
      uid,
      data: data || '',
      name,
      viewId,
      userId,
      tenantId,
    }
  }
}
